import { AxiosResponse } from 'axios';

export const responseInterceptor = (response: AxiosResponse) => {
  if (response.data && 'success' in response.data) {
    if (response.data.success) {
      response.data = response.data.data;
    } else {
      return Promise.reject(new Error(response.data.message));
    }
  }
  return response;
};